import React, { useState } from 'react';
import {
  TabProps,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '../../../../../../../../../components/Common/UI/Tabs';
import ModalMediaList from './List';
import { cn } from '../../../../../../../../../utils/styles';
import { Button } from '../../../../../../../../../components/Common/UI/Button';
import Icons from '../../../../../../../../../components/Common/Icons/Icons';
import { Input } from '../../../../../../../../../components/Common/UI/Input';
import Separator from '../../../../../../../../../components/Common/UI/Separator';
import SelectedItem from './Selected';

export enum EnumMediaType {
  images = 'images',
  qrCodes = 'qrCodes',
}

function MediaModalContent() {
  const [currentTab, setCurrentTab] = useState<EnumMediaType>(EnumMediaType.images);

  const tabs: TabProps[] = [
    {
      value: EnumMediaType.images,
      label: 'Images',
      content: <ModalMediaList type={EnumMediaType.images} />,
    },
    {
      value: EnumMediaType.qrCodes,
      label: 'QR Codes',
      content: <ModalMediaList type={EnumMediaType.qrCodes} />,
    },
  ];

  return (
    <div className="grid gap-[10px] grid-cols-[auto,auto]">
      <Tabs defaultValue={EnumMediaType.images} onValueChange={val => setCurrentTab(val as EnumMediaType)}>
        <div className="grid gap-[37px] items-center justify-start grid-cols-[auto,auto]">
          <TabsList className="h-[44px] rounded-lg">
            {tabs.map(({ value, label }) => (
              <TabsTrigger
                key={`${value}-trigger`}
                value={value}
                className={cn('h-[36px] min-w-[120px] rounded-lg font-bold', {
                  'opacity-60': value !== currentTab,
                })}
              >
                {label}
              </TabsTrigger>
            ))}
          </TabsList>
          <div className="flex gap-[10px]">
            <Button variant="secondary" size="icon" className="h-[44px] w-[44px]">
              <Icons.Layout className="[&_path]:!fill-primary" />
            </Button>
            <Button variant="secondary">Filter</Button>
            <Input placeholder="Search" variant="white" icon={<Icons.Search />} className="w-[200px]" />
          </div>
        </div>
        <Separator className="!mt-[10px]" />
        {tabs.map(({ value, content }) => (
          <TabsContent key={value} value={value}>
            {content}
          </TabsContent>
        ))}
      </Tabs>
      <SelectedItem currentTab={currentTab} />
    </div>
  );
}

export default MediaModalContent;
